module.exports = __webpack_public_path__ + "static/media/SZST.a916a91a.png";